export default __webpack_public_path__ + "static/media/play-store.c852c2fb.png";